<div id="toggler" class="row py-2 align-items-center" (click)="isCollapsed = !isCollapsed">
    <div class="col-1">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
    <div data-material="material-number" class="col-4">{{ material.materialIdentifier.materialNumber.value }}</div>
    <div class="col-4 form-control-static">{{ material.description.value }}</div>
    <div class="col-3 d-flex align-items-center">
        <span class="pe-2" data-material="delivered-quantity"> {{ material.deliveredQuantity }}</span>
    </div>
</div>
<div
    *ngIf="!isCollapsed"
    class="material-expanded-content py-3"
    [ngClass]="{ collapsed: isCollapsed, expanded: !isCollapsed }"
>
    <div class="row align-items-center">
        <div *ngIf="isModelNotification" class="col d-flex justify-content-center my-2">
            <pace-core-number-stepper
                (click)="$event.stopPropagation()"
                [(model)]="material.quantity"
                name="quantity"
                [ariaLabel]="'CONFIRMATION_MATERIAL_STOCK_QUANTITY_ARIA_LABEL' | translate"
            ></pace-core-number-stepper>
        </div>
    </div>
    <div class="row align-items-center my-2">
        <span class="fw-bold col-7 col-sm-4 offset-1" translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_BATCHID"></span>
        <span data-material="batch-number-legacy" class="col-4 form-control-static">
            {{ material.batchNumberLegacy ? material.batchNumberLegacy : material.batchNumber.value }}<br />
        </span>
    </div>
    <div class="row align-items-center">
        <span
            class="fw-bold col-7 col-sm-4 offset-1"
            translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_STORAGE_LOCATION"
        ></span>
        <span data-material="storage-location" class="col-4 form-control-static" [ngClass]="">
            {{ material.storageLocation.value }}<br />
        </span>
    </div>
    <div class="row align-items-center my-2">
        <span
            class="fw-bold col-7 col-sm-4 offset-1"
            translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_STORAGE_DESC"
        ></span>
        <span data-material="storage-location-desc" class="col-4 form-control-static">
            {{ material.storageLocationDesc.value }}<br />
        </span>
    </div>
</div>
